import { RadioGroup } from '@mui/material';
import type { FunctionComponent } from 'react';

import { LabeledRadio } from '../Forms';

export type RadioFilterOption = {
  label: string;
  value: string;
};

export type Props = {
  /**
   * Filter group title
   */
  title: string;
  /**
   * Array of filter options.
   */
  options: RadioFilterOption[];
  /**
   * Selected Value
   */
  value?: string;
  /**
   * Default selected option
   */
  defaultValue?: string;
  /**
   * Function called when an item is selected
   */
  onSelect: (value: string) => void;
  /**
   * Whether or not the radio buttons should be disabled.
   */
  isDisabled?: boolean;
};

/**
 * Renders a filter group with filter options as radio buttons
 * @deprecated - Use FilterCardRadios instead.
 */
const RadioFilterGroup: FunctionComponent<Props> = ({
  title,
  options,
  value,
  defaultValue,
  onSelect,
  isDisabled,
}) => {
  return (
    <RadioGroup
      className="radio-filter-group"
      value={value}
      defaultValue={defaultValue}
      onChange={(_event, val) => (onSelect(val))}>
      {title && <span className="radio-filter-group-title">{title}</span>}
      <div className="radio-filter-group-checks">
        {options.map(option =>
          <LabeledRadio
            label={option.label}
            value={option.value}
            isDisabled={isDisabled}
          />)}
      </div>
    </RadioGroup>
  );
};

export default RadioFilterGroup;
